import React from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { QuoteProvider } from './context/QuoteContext';
import { AdminProvider, useAdmin } from './context/AdminContext';
import { Toaster } from './components/ui/toaster';
import Header from './components/Header';
import Footer from './components/Footer';
import ScrollToTop from './components/ScrollToTop';
import AIChatbot from './components/AIChatbot';
import Home from './pages/Home';
import ProductList from './pages/ProductList';
import ProductDetail from './pages/ProductDetail';
import QuoteCart from './pages/QuoteCart';
import RequestQuote from './pages/RequestQuote';
import Contact from './pages/Contact';
import Search from './pages/Search';
import Categories from './pages/Categories';
import {
  AdminLogin,
  AdminDashboard,
  AdminProducts,
  AdminUsers,
  AdminQuotes,
  AdminContacts
} from './pages/admin';

// Protected Route component for admin pages
const ProtectedRoute = ({ children }) => {
  const { user, loading } = useAdmin();
  
  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center">
        <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-pink-600"></div>
      </div>
    );
  }
  
  if (!user) {
    return <Navigate to="/admin/login" replace />;
  }
  
  return children;
};

// Public layout wrapper (with header/footer)
const PublicLayout = ({ children }) => (
  <div className="App flex flex-col min-h-screen">
    <Header />
    <main className="flex-grow">{children}</main>
    <Footer />
    <AIChatbot />
    <Toaster />
  </div>
);

function App() {
  return (
    <AdminProvider>
      <QuoteProvider>
        <BrowserRouter>
          <ScrollToTop />
          <Routes>
            {/* Admin Routes (no header/footer) */}
            <Route path="/admin/login" element={<AdminLogin />} />
            <Route path="/admin/dashboard" element={<ProtectedRoute><AdminDashboard /></ProtectedRoute>} />
            <Route path="/admin/products" element={<ProtectedRoute><AdminProducts /></ProtectedRoute>} />
            <Route path="/admin/users" element={<ProtectedRoute><AdminUsers /></ProtectedRoute>} />
            <Route path="/admin/quotes" element={<ProtectedRoute><AdminQuotes /></ProtectedRoute>} />
            <Route path="/admin/contacts" element={<ProtectedRoute><AdminContacts /></ProtectedRoute>} />
            <Route path="/admin" element={<Navigate to="/admin/dashboard" replace />} />
            
            {/* Public Routes (with header/footer) */}
            <Route path="/" element={<PublicLayout><Home /></PublicLayout>} />
            <Route path="/categories" element={<PublicLayout><Categories /></PublicLayout>} />
            <Route path="/products" element={<PublicLayout><ProductList /></PublicLayout>} />
            <Route path="/products/:category" element={<PublicLayout><ProductList /></PublicLayout>} />
            <Route path="/product/:productId" element={<PublicLayout><ProductDetail /></PublicLayout>} />
            <Route path="/quote" element={<PublicLayout><QuoteCart /></PublicLayout>} />
            <Route path="/quote-cart" element={<PublicLayout><QuoteCart /></PublicLayout>} />
            <Route path="/request-quote" element={<PublicLayout><RequestQuote /></PublicLayout>} />
            <Route path="/contact" element={<PublicLayout><Contact /></PublicLayout>} />
            <Route path="/search" element={<PublicLayout><Search /></PublicLayout>} />
          </Routes>
        </BrowserRouter>
      </QuoteProvider>
    </AdminProvider>
  );
}

export default App;
